import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);
const KEY = "alfaz_staff_token";

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem(KEY));

  const save = useCallback((t) => {
    if (t) localStorage.setItem(KEY, t); else localStorage.removeItem(KEY);
    setToken(t);
  }, []);

  const value = useMemo(() => ({
    token,
    login: async (email, password) => save((await api.post("/auth/login", { email, password })).data.token),
    register: async (name, email, password) => save((await api.post("/auth/register", { name, email, password })).data.token),
    logout: () => save(null),
  }), [token, save]);

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
